export const state = () => ({
  goal: null,
  values: {},
  footnotes: {},
})

export const getters = {
  whichGoalIsSet(state) {
    if (Object.keys(state.values).length) {
      return state.goal
    } else {
      return null
    }
  },
}

export const mutations = {
  set_values_footnotes(state, { goal, values, footnotes }) {
    if (Object.keys(values).length && goal) {
      state.goal = goal
      state.values = values
      if (footnotes) state.footnotes = footnotes
    }
  },
}

export const actions = {
  set_values_footnotes({ commit }, { goal, values, footnotes }) {
    commit('set_values_footnotes', { goal, values, footnotes })
  },

  /**
   * The footnotes are indexed by a metricCycleKey like:
   *  2|2.1|Aimsweb|All|All|at_grade|Fall
   *  which has 7 component parts.
   * This function filters the footnotes to return only those
   * where the parts of the metric key match
   * @param {*} param0
   * @param {*} metricComponents an objects with following pattern: { number: string, number: string } where numbers are the index in the metric key
   *
   */
  get_footnotes_by_metric_components({ state }, metricComponents) {
    if (Object.keys(state.footnotes).length && state.goal) {
      // type check
      if (!(typeof metricComponents === 'object')) {
        throw new TypeError(
          'the supplied metricComponents must be in form { number: string, number: string}, where numbers are the index to the place within the metricCycle key'
        )
      }
      const indices = state.footnotes.metricCycleKey
        .map(({ text }, index) => ({ text, index }))
        .filter(({ text }) => {
          const metricKeyArr = text.split('|')
          let isMatch = true
          Object.keys(metricComponents).forEach((key) => {
            const i = parseInt(key) - 1
            // if this component part does not match what's in the key set isMatch as false
            if (!(isFinite(i) && metricKeyArr[i] === metricComponents[key])) {
              isMatch = false
            }
          })
          return isMatch
        })
        .map(({ text, index }) => index)
      return this.$qlik.filterFieldValuesByIndices(state.footnotes, indices)
    } else {
      return {}
    }
  },
}
